import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { baseUrl, userLocation, ipAddress, userName } from "../Univ.js";

function MachinePage() {

  const [rows, setRows] = useState([]);
  const [WCs, setWCs] = useState([]);

  const [data, setData] = useState({
    product: "",
    version: ""
  });

  useEffect(() => {
    fetchBOM();
    fetchWCs();
  }, []);

  const fetchBOM = () => {
    axios.get(baseUrl + "machines/")
      .then(res => {
        setRows(res.data);
      });
  };

  const fetchWCs = () => {
    axios.get(baseUrl + "workcenters/")
      .then(res => {
        setWCs(res.data);
      });
  };

  const inputHandler = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const formSubmit = () => {

    if (!data.name) {
      Swal.fire("Error", "Name is required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("workcenter", data.workcenter);
    _formData.append("name", data.name);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.post(baseUrl + "machines/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(response => {
      if (response.status === 200 || response.status === 201) {

        Swal.fire({
          title: "BOM Created",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });

        setData({
          product: "",
          version: ""
        });

        fetchBOM();
      }
    })
    .catch(() => {
      Swal.fire("Error", "Something went wrong", "error");
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Confirm",
      text: "Are you sure you want to delete this?",
      icon: "warning",
      confirmButtonText: "Yes",
      showCancelButton: true
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(baseUrl + "machines/" + id + "/")
          .then(() => {
            Swal.fire("Deleted", "BOM deleted", "success");
            fetchBOM();
          });
      }
    });
  };

  const columns = [
    { field: "id", headerName: "ID", width: 80 },
    {
      field: "workcenter",
      headerName: "Work Centers",
      width: 150,
       renderCell: (params) => {
        if (params && params.row && params.row.workcenter) {
          if (params.row.workcenter !== null && params.row.workcenter !== 0) {
            return params.row.workcenter?.name;
          }
        }
        return 'Unknown';
      },
    },
    { field: "name", headerName: "Name", width: 150 },
    {
      field: "edit",
      headerName: "Edit",
      renderCell: (params) => (
        <Link
          to={`/machines/edit/${params.row.id}`}
          target="_blank"
          className="btn btn-warning btn-sm"
        >
          Edit
        </Link>
      ),
      width: 120
    },
    {
      field: "delete",
      headerName: "Delete",
      renderCell: (params) => (
        <button
          onClick={() => handleDelete(params.row.id)}
          className="btn btn-danger btn-sm"
        >
          Delete
        </button>
      ),
      width: 120
    }
  ];

  return (
    <div className="container mt-4">

      {/* Form */}
      <div className="card p-4 mb-4">
        <h4>Add Machines</h4>

        <select
          className="form-control mt-3"
          name="workcenter"
          value={data.workcenter}
          onChange={inputHandler}
        >
          <option value="">Select WCs</option>
          {WCs.map(prod => (
            <option key={prod.id} value={prod.id}>
              {prod.name}
            </option>
          ))}
        </select>

        <input
          type="text"
          className="form-control mt-3"
          placeholder="Name"
          name="name"
          value={data.name}
          onChange={inputHandler}
        />

        <button
          className="btn btn-success mt-3"
          onClick={formSubmit}
        >
          Submit
        </button>
      </div>

      {/* DataGrid */}
      <div className="card p-3">
        <DataGrid
          sx={{
            boxShadow: 4,
            border: 4,
            borderColor: "primary.light",
            "& .MuiDataGrid-cell:hover": {
              color: "primary.main",
            },
          }}
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight
          components={{ Toolbar: GridToolbar }}
        />
      </div>

    </div>
  );
}

export default MachinePage;
